<template>
  <section class="hortense-faq-display" v-if="faqs && faqs.length > 0">
    <h3 class="faq-title" :class="isMobile ? 'merriweather-reg-20' : 'merriweather-reg-24'">
      Questions fréquentes
    </h3>

    <div class="gn-accordion faq-accordion">
      <div
        v-for="(faq, index) in faqs"
        :key="faq.id"
        class="acc-item"
      >
        <button
          class="acc-head"
          @click="toggleFaq(index)"
          :class="{ active: expandedFaqIndex === index }"
        >
          <span class="raleway-semi-p15">{{ faq.question }}</span>
          <svg
            :class="{ open: expandedFaqIndex === index }"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              d="M7 10l5 5 5-5"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        <transition name="acc">
          <div v-show="expandedFaqIndex === index" class="acc-panel">
            <div class="raleway">{{ faq.answer }}</div>
          </div>
        </transition>
      </div>

      <div v-if="faqs.length === 0" class="no-faqs-message">
        <p class="raleway-reg-p15">Aucune question disponible.</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'hortense-faq-display',
  props: {
    faqs: {
      type: Array,
      default: () => []
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expandedFaqIndex: null
    };
  },
  methods: {
    toggleFaq(index) {
      this.expandedFaqIndex = this.expandedFaqIndex === index ? null : index;
    }
  }
};
</script>

<style scoped>
.hortense-faq-display {
  padding: 36px 0 10px;
}

.faq-title {
  line-height: 1.2;
  margin-bottom: 20px;
}

.faq-title span {
  display: block;
  margin-top: 6px;
}

.gn-accordion {
  background: #f7f6f3;
  border-radius: 12px;
  padding: 20px;
  margin: 28px auto 16px;
  max-width: 1100px;
}

.faq-accordion {
  margin: 0;
  max-width: none;
}

.acc-item + .acc-item {
  border-top: 1px solid #dcdcd2;
}

.acc-head {
  width: 100%;
  background: transparent;
  border: none;
  padding: 16px 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  color: #2c5c49;
  cursor: pointer;
  transition: all 0.3s ease;
}

.acc-head:hover {
  color: #2f6b57;
}

.acc-head.active {
  color: #2f6b57;
}

.acc-head svg {
  transition: transform 0.25s ease;
  flex-shrink: 0;
  margin-left: 15px;
}

.acc-head svg.open {
  transform: rotate(180deg);
}

.acc-panel {
  padding: 0 6px 16px 6px;
}

.acc-panel .raleway {
  margin: 0;
  color: #39423d;
  line-height: 1.8;
  font-family: 'Raleway', sans-serif;
  font-size: 15px;
}

.no-faqs-message {
  padding: 20px 6px;
  text-align: center;
  color: #999;
}

.acc-enter-active,
.acc-leave-active {
  transition: height 0.22s ease, opacity 0.22s ease;
}

.acc-enter,
.acc-leave-to {
  height: 0;
  opacity: 0;
}

@media (max-width: 768px) {
  .hortense-faq-display {
    padding: 24px 0 10px;
  }

  .gn-accordion {
    padding: 15px;
  }

  .acc-head {
    padding: 12px 4px;
  }

  .acc-panel {
    padding: 0 4px 12px 4px;
  }
}
</style>
